import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})

export class AppHeaderComponent implements OnInit {

  username: string;
  rol: any;

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.username = currentUser.username;
    this.rol = currentUser.rol;
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/app-header/app-header.component.ts